import { RootStore } from 'stores/pet-profile-new/types';
import { PetProfile } from 'types/pet-profile';
import { PetType } from 'constants/pet-type';
import { INITIAL_CAT_STATE, INITIAL_DOG_STATE } from 'stores/pet-profile-new/constants';

interface GetCurrentPetProfile {
  state: RootStore;
  customerPets: PetProfile[];
}

export const getCurrentPetProfile = ({ state, customerPets }: GetCurrentPetProfile): PetProfile => {
  const { activePetProfile, petType } = state;
  const activeProfile = customerPets
    .filter((petProfile) => petProfile.petType === petType)
    .find((profile) => profile.id === activePetProfile[petType]);

  if (activeProfile) {
    return activeProfile;
  }

  // fallback option in case active pet profile has not been found for any reason
  const firstCustomerPet = customerPets.find((p) => p.petType === petType);
  if (firstCustomerPet) {
    return firstCustomerPet;
  }

  return petType === PetType.Cat ? INITIAL_CAT_STATE : INITIAL_DOG_STATE;
};
